@let isDeviceMobile = isDeviceMobile$ | async;
@let isDeviceTablet = isDeviceTablet$ | async;

<div [id]="getWidgetId" class="gallery-widget-width">
    <div [class]="classes?.galleryWrapper">
        @if (!images.length) {
            <div [class]="classes?.imageWrapper" style="padding-top: 0">
                <img [class]="classes?.gridImage" [src]="BLANK_IMAGE" />
            </div>
        }

        @if (images.length) {
            @if (!isCarousel) {
                @if (!isMasonry) {
                    <div
                        [class.mobileViewWrapper]="isDeviceMobile"
                        [class.tabletViewWrapper]="isDeviceTablet"
                        [class]="classes?.gridContainer"
                    >
                        @for (image of images; track instanceId(i, image); let i = $index) {
                            <div
                                [class.mobileGridItem]="isDeviceMobile"
                                [class.tabletGridItem]="isDeviceTablet"
                                [class]="classes?.gridItem"
                            >
                                <div
                                    #resizeBox
                                    mwlResizable
                                    class="image-wrapper"
                                    [class]="classes?.imageWrapper"
                                    (resizeStart)="onResizeStart($event, resizeBox)"
                                    (resizing)="onResizing($event, resizeBox)"
                                    (resizeEnd)="onResizeEnd($event, resizeBox, i)"
                                    [style.paddingTop.%]="getImagePaddingTop(images[i])"
                                    (mouseenter)="mouseImgIn(i)"
                                    (mouseleave)="mouseImgOut(i)"
                                >
                                    @if (image?.overlayImage && image.isImageEffect) {
                                        <img
                                            #overlayImageRef
                                            [class]="classes?.gridImage + ' shape '"
                                            [ngClass]="{ overlayImage: overlayImageSrc(image) }"
                                            [style.objectPosition]="
                                                image &&
                                                (image.backgroundPositionX || 50) +
                                                    '% ' +
                                                    (image.backgroundPositionY || 50) +
                                                    '%'
                                            "
                                            [src]="overlayImageSrc(image)"
                                        />
                                    }
                                    <picture [spFallbackImg]="formatImageFallbackURL(image)">
                                        @for (source of image.srcSets; track source) {
                                            <source [srcset]="source.url" [media]="source.media" />
                                        }
                                        <img
                                            #imageRef
                                            [class]="classes?.gridImage + ' shape '"
                                            [ngClass]="image.isImageEffect && classes?.['imageMask' + i]"
                                            (load)="resizeOnload($event.target, resizeBox, i)"
                                            [src]="formatImageURL(image)"
                                            [alt]="image.alt"
                                            [style.objectPosition]="
                                                (image.backgroundPositionX || 50) +
                                                '% ' +
                                                (image.backgroundPositionY || 50) +
                                                '%'
                                            "
                                            (mousedown)="mouseDown($event, image)"
                                            (mousemove)="move($event, imageRef)"
                                            (mouseleave)="mouseUp(i)"
                                            (mouseup)="mouseUp(i)"
                                        />
                                    </picture>
                                    @if (image.isImageEffect) {
                                        <div [class]="classes?.['imageDescription' + i]">
                                            <div [class]="classes?.['text' + i]">
                                                <span>{{ image.description }}</span>
                                            </div>
                                        </div>
                                    }
                                    <div class="dragHandle bottom" mwlResizeHandle [resizeEdges]="{ bottom: true }">
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g>
                                                <path
                                                    d="M8.7071 15.6066C8.51956 15.7941 8.26519 15.8995 7.99998 15.8995C7.73476 15.8995 7.48042 15.7941 7.29288 15.6066L5.17156 13.4853C5.03195 13.3455 4.93688 13.1674 4.89837 12.9736C4.85986 12.7798 4.87963 12.5789 4.95519 12.3963C5.00566 12.275 5.07913 12.1645 5.17156 12.0711C5.35906 11.884 5.61311 11.779 5.87796 11.779L6.99943 11.779L7.00085 10C6.99854 9.86724 7.02271 9.73535 7.07192 9.61202C7.12113 9.48869 7.19441 9.3764 7.28749 9.28169C7.38056 9.18699 7.49155 9.11175 7.614 9.0604C7.73646 9.00905 7.86792 8.98263 8.0007 8.98263C8.13348 8.98263 8.26493 9.00906 8.38739 9.06041C8.50984 9.11176 8.62085 9.18698 8.71393 9.28168C8.807 9.37639 8.88029 9.48869 8.9295 9.61202C8.97871 9.73535 9.00286 9.86724 9.00055 10L8.99984 11.7783L10.1213 11.7783C10.3191 11.7784 10.5124 11.837 10.6768 11.9469C10.8412 12.0568 10.9693 12.2129 11.045 12.3956C11.1207 12.5783 11.1405 12.7793 11.102 12.9733C11.0634 13.1672 10.9682 13.3454 10.8284 13.4853L8.7071 15.6066ZM8.0007 6.99985C7.73554 6.99981 7.48124 6.89446 7.29374 6.70696C7.10625 6.51946 7.00089 6.26516 7.00085 6L7.00014 4.22167L5.87867 4.22167C5.68092 4.22164 5.48761 4.16299 5.3232 4.05312C5.15878 3.94325 5.03063 3.78708 4.95495 3.60438C4.87927 3.42168 4.85946 3.22067 4.89801 3.02672C4.93657 2.83276 5.03176 2.65458 5.17156 2.51472L7.29288 0.393397C7.48042 0.20586 7.73478 0.100513 8 0.100513C8.26521 0.100513 8.51956 0.20586 8.70709 0.393397L10.8284 2.51472C10.9679 2.65457 11.0629 2.83261 11.1013 3.02638C11.1398 3.22015 11.12 3.42097 11.0444 3.60349C10.9688 3.78602 10.8409 3.94206 10.6767 4.05195C10.5126 4.16185 10.3196 4.22065 10.122 4.22096L9.00055 4.22096L9.00055 6C9.00051 6.26516 8.89516 6.51946 8.70766 6.70696C8.52016 6.89446 8.26586 6.99981 8.0007 6.99985Z"
                                                    fill="white"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
                @if (isMasonry) {
                    <div
                        [class.mobileViewWrapper]="isDeviceMobile"
                        [class.tabletViewWrapper]="isDeviceTablet"
                        [class]="classes?.gridContainer"
                    >
                        @for (item of masonryArrays; track instanceId(columnIndex, item); let columnIndex = $index) {
                            <div [class.mobileGridItem]="isDeviceMobile" [class.tabletGridItem]="isDeviceTablet">
                                @for (image of item; track instanceId(imageIndex, image); let imageIndex = $index) {
                                    <div [class]="classes?.gridItem">
                                        <div
                                            class="image-wrapper"
                                            [class]="classes?.imageWrapper"
                                            #resizeBox
                                            mwlResizable
                                            (resizeStart)="onResizeStart($event, resizeBox)"
                                            (resizing)="onResizing($event, resizeBox)"
                                            (resizeEnd)="
                                                onResizeEnd(
                                                    $event,
                                                    resizeBox,
                                                    imageIndex * masonryArrays.length + columnIndex
                                                )
                                            "
                                            [style.paddingTop.%]="
                                                (images[imageIndex * masonryArrays.length + columnIndex].resizedHeight /
                                                    images[imageIndex * masonryArrays.length + columnIndex]
                                                        .resizedWidth) *
                                                100
                                            "
                                            (mouseenter)="mouseImgIn(imageIndex)"
                                            (mouseleave)="mouseImgOut(imageIndex)"
                                        >
                                            @if (image?.overlayImage) {
                                                <img
                                                    #overlayImageRef
                                                    [class]="classes?.gridImage + ' shape '"
                                                    [ngClass]="{
                                                        overlayImage: overlayImageSrc(image),
                                                        imageMask: image.isImageEffect,
                                                    }"
                                                    [style.objectPosition]="
                                                        image &&
                                                        (image.backgroundPositionX || 50) +
                                                            '% ' +
                                                            (image.backgroundPositionY || 50) +
                                                            '%'
                                                    "
                                                    [src]="overlayImageSrc(image)"
                                                />
                                            }
                                            <picture [spFallbackImg]="formatImageFallbackURL(image)">
                                                @for (source of image.srcSets; track source) {
                                                    <source [srcset]="source.url" [media]="source.media" />
                                                }
                                                <img
                                                    #imageRef
                                                    [class]="
                                                        classes?.gridImage +
                                                        ' shape ' +
                                                        classes?.['image' + columnIndex + '-' + imageIndex]
                                                    "
                                                    [ngClass]="
                                                        image.isImageEffect &&
                                                        classes?.['imageMask' + columnIndex + '-' + imageIndex]
                                                    "
                                                    (load)="
                                                        resizeOnload(
                                                            $event.target,
                                                            resizeBox,
                                                            imageIndex * masonryArrays.length + columnIndex
                                                        )
                                                    "
                                                    [src]="formatImageURL(image)"
                                                    [alt]="image.alt"
                                                    [style.objectPosition]="
                                                        (image.backgroundPositionX || 50) +
                                                        '% ' +
                                                        (image.backgroundPositionY || 50) +
                                                        '%'
                                                    "
                                                    (mousedown)="mouseDown($event, image)"
                                                    (mousemove)="move($event, imageRef)"
                                                    (mouseleave)="
                                                        mouseUp(imageIndex * masonryArrays.length + columnIndex)
                                                    "
                                                    (mouseup)="mouseUp(imageIndex * masonryArrays.length + columnIndex)"
                                                />
                                            </picture>
                                            @if (image.isImageEffect) {
                                                <div
                                                    [class]="
                                                        classes?.['imageDescription' + columnIndex + '-' + imageIndex]
                                                    "
                                                >
                                                    <div [class]="classes?.['text' + columnIndex + '-' + imageIndex]">
                                                        <span>{{ image.description }}</span>
                                                    </div>
                                                </div>
                                            }
                                            <div
                                                class="dragHandle bottom"
                                                mwlResizeHandle
                                                [resizeEdges]="{ bottom: true }"
                                            >
                                                <svg
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 16 16"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <g>
                                                        <path
                                                            d="M8.7071 15.6066C8.51956 15.7941 8.26519 15.8995 7.99998 15.8995C7.73476 15.8995 7.48042 15.7941 7.29288 15.6066L5.17156 13.4853C5.03195 13.3455 4.93688 13.1674 4.89837 12.9736C4.85986 12.7798 4.87963 12.5789 4.95519 12.3963C5.00566 12.275 5.07913 12.1645 5.17156 12.0711C5.35906 11.884 5.61311 11.779 5.87796 11.779L6.99943 11.779L7.00085 10C6.99854 9.86724 7.02271 9.73535 7.07192 9.61202C7.12113 9.48869 7.19441 9.3764 7.28749 9.28169C7.38056 9.18699 7.49155 9.11175 7.614 9.0604C7.73646 9.00905 7.86792 8.98263 8.0007 8.98263C8.13348 8.98263 8.26493 9.00906 8.38739 9.06041C8.50984 9.11176 8.62085 9.18698 8.71393 9.28168C8.807 9.37639 8.88029 9.48869 8.9295 9.61202C8.97871 9.73535 9.00286 9.86724 9.00055 10L8.99984 11.7783L10.1213 11.7783C10.3191 11.7784 10.5124 11.837 10.6768 11.9469C10.8412 12.0568 10.9693 12.2129 11.045 12.3956C11.1207 12.5783 11.1405 12.7793 11.102 12.9733C11.0634 13.1672 10.9682 13.3454 10.8284 13.4853L8.7071 15.6066ZM8.0007 6.99985C7.73554 6.99981 7.48124 6.89446 7.29374 6.70696C7.10625 6.51946 7.00089 6.26516 7.00085 6L7.00014 4.22167L5.87867 4.22167C5.68092 4.22164 5.48761 4.16299 5.3232 4.05312C5.15878 3.94325 5.03063 3.78708 4.95495 3.60438C4.87927 3.42168 4.85946 3.22067 4.89801 3.02672C4.93657 2.83276 5.03176 2.65458 5.17156 2.51472L7.29288 0.393397C7.48042 0.20586 7.73478 0.100513 8 0.100513C8.26521 0.100513 8.51956 0.20586 8.70709 0.393397L10.8284 2.51472C10.9679 2.65457 11.0629 2.83261 11.1013 3.02638C11.1398 3.22015 11.12 3.42097 11.0444 3.60349C10.9688 3.78602 10.8409 3.94206 10.6767 4.05195C10.5126 4.16185 10.3196 4.22065 10.122 4.22096L9.00055 4.22096L9.00055 6C9.00051 6.26516 8.89516 6.51946 8.70766 6.70696C8.52016 6.89446 8.26586 6.99981 8.0007 6.99985Z"
                                                            fill="white"
                                                        />
                                                    </g>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            }
            @if (isCarousel) {
                @if (carouselOptions.type === "default" && renderDefaultSwiper) {
                    <swiper
                        [class.mobileViewWrapper]="isDeviceMobile"
                        [class.tabletViewWrapper]="isDeviceTablet"
                        class="default-swiper swipper-media-wrapper"
                        [ngClass]="{
                            'with-bottom-navigation': isHasBottomSpace(),
                            outsideArrowWrapper: carouselOptions.isOutsideContainerArrow,
                        }"
                        [config]="swiperConfig"
                        style="--swiper-navigation-color: {{
                            carouselOptions.knobsColor
                        }}; --swiper-pagination-color: {{
                            carouselOptions.dotsColor ? carouselOptions.dotsColor : '#000'
                        }}; --swiper-pagination-bullet-inactive-color: {{
                            carouselOptions.dotsColor ? carouselOptions.dotsColor : '#000'
                        }}; --swiper-navigation-size: {{
                            carouselOptions.arrowSize ? carouselOptions.arrowSize + 'px' : '44px'
                        }}; --swiper-navigation-size-tablet: {{
                            carouselOptions.arrowSizeTablet ? carouselOptions.arrowSizeTablet + 'px' : '44px'
                        }}; --swiper-navigation-size-mobile: {{
                            carouselOptions.arrowSizeMobile ? carouselOptions.arrowSizeMobile + 'px' : '44px'
                        }};"
                        [rewind]="true"
                        [navigation]="navigationConfig"
                        [pagination]="{ clickable: true, dynamicBullets: true }"
                        [grabCursor]="true"
                        [allowTouchMove]="false"
                        (swiper)="setSwiper($event)"
                        [breakpoints]="getSwiperBreakpoints(isDeviceMobile, isDeviceTablet)"
                    >
                        @for (image of images; track instanceId(i, image); let i = $index) {
                            <ng-template swiperSlide>
                                <div
                                    class="image-wrapper"
                                    #resizeBox
                                    mwlResizable
                                    (resizeStart)="onResizeStart($event, resizeBox)"
                                    (resizing)="onResizing($event, resizeBox)"
                                    (resizeEnd)="onResizeEnd($event, resizeBox, i)"
                                    [class]="classes?.imageWrapper"
                                    [style.paddingTop.%]="getImagePaddingTop(images[i])"
                                    (mouseenter)="mouseImgIn(i)"
                                    (mouseleave)="mouseImgOut(i)"
                                >
                                    @if (image?.overlayImage) {
                                        <img
                                            #overlayImageRef
                                            [class]="classes?.gridImage + ' shape ' + classes?.['image' + i]"
                                            [ngClass]="{ overlayImage: overlayImageSrc(image) }"
                                            [style.objectPosition]="
                                                image &&
                                                (image.backgroundPositionX || 50) +
                                                    '% ' +
                                                    (image.backgroundPositionY || 50) +
                                                    '%'
                                            "
                                            [src]="overlayImageSrc(image)"
                                        />
                                    }
                                    <picture [spFallbackImg]="formatImageFallbackURL(image)">
                                        @for (source of image.srcSets; track source) {
                                            <source [srcset]="source.url" [media]="source.media" />
                                        }
                                        <img
                                            #imageRef
                                            [class]="classes?.gridImage + ' shape ' + classes?.['image' + i]"
                                            [ngClass]="image.isImageEffect && classes?.['imageMask' + i]"
                                            (load)="resizeOnload($event.target, resizeBox, i)"
                                            [src]="formatImageURL(image)"
                                            [alt]="image.alt"
                                            [style.objectPosition]="
                                                (image.backgroundPositionX || 50) +
                                                '% ' +
                                                (image.backgroundPositionY || 50) +
                                                '%'
                                            "
                                            (mousedown)="mouseDown($event, image)"
                                            (mousemove)="move($event, imageRef)"
                                            (mouseleave)="mouseUp(i)"
                                            (mouseup)="mouseUp(i)"
                                        />
                                    </picture>
                                    @if (image.isImageEffect) {
                                        <div [class]="classes?.['imageDescription' + i]">
                                            <div [class]="classes?.['text' + i]">
                                                <span>{{ image.description }}</span>
                                            </div>
                                        </div>
                                    }
                                    <div class="dragHandle bottom" mwlResizeHandle [resizeEdges]="{ bottom: true }">
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g>
                                                <path
                                                    d="M8.7071 15.6066C8.51956 15.7941 8.26519 15.8995 7.99998 15.8995C7.73476 15.8995 7.48042 15.7941 7.29288 15.6066L5.17156 13.4853C5.03195 13.3455 4.93688 13.1674 4.89837 12.9736C4.85986 12.7798 4.87963 12.5789 4.95519 12.3963C5.00566 12.275 5.07913 12.1645 5.17156 12.0711C5.35906 11.884 5.61311 11.779 5.87796 11.779L6.99943 11.779L7.00085 10C6.99854 9.86724 7.02271 9.73535 7.07192 9.61202C7.12113 9.48869 7.19441 9.3764 7.28749 9.28169C7.38056 9.18699 7.49155 9.11175 7.614 9.0604C7.73646 9.00905 7.86792 8.98263 8.0007 8.98263C8.13348 8.98263 8.26493 9.00906 8.38739 9.06041C8.50984 9.11176 8.62085 9.18698 8.71393 9.28168C8.807 9.37639 8.88029 9.48869 8.9295 9.61202C8.97871 9.73535 9.00286 9.86724 9.00055 10L8.99984 11.7783L10.1213 11.7783C10.3191 11.7784 10.5124 11.837 10.6768 11.9469C10.8412 12.0568 10.9693 12.2129 11.045 12.3956C11.1207 12.5783 11.1405 12.7793 11.102 12.9733C11.0634 13.1672 10.9682 13.3454 10.8284 13.4853L8.7071 15.6066ZM8.0007 6.99985C7.73554 6.99981 7.48124 6.89446 7.29374 6.70696C7.10625 6.51946 7.00089 6.26516 7.00085 6L7.00014 4.22167L5.87867 4.22167C5.68092 4.22164 5.48761 4.16299 5.3232 4.05312C5.15878 3.94325 5.03063 3.78708 4.95495 3.60438C4.87927 3.42168 4.85946 3.22067 4.89801 3.02672C4.93657 2.83276 5.03176 2.65458 5.17156 2.51472L7.29288 0.393397C7.48042 0.20586 7.73478 0.100513 8 0.100513C8.26521 0.100513 8.51956 0.20586 8.70709 0.393397L10.8284 2.51472C10.9679 2.65457 11.0629 2.83261 11.1013 3.02638C11.1398 3.22015 11.12 3.42097 11.0444 3.60349C10.9688 3.78602 10.8409 3.94206 10.6767 4.05195C10.5126 4.16185 10.3196 4.22065 10.122 4.22096L9.00055 4.22096L9.00055 6C9.00051 6.26516 8.89516 6.51946 8.70766 6.70696C8.52016 6.89446 8.26586 6.99981 8.0007 6.99985Z"
                                                    fill="white"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </ng-template>
                        }
                    </swiper>
                }
                @if (carouselOptions.type === "default" && carouselOptions.isOutsideContainerArrow) {
                    <div
                        [class.mobileCustomBtn]="isDeviceMobile"
                        [class.tabletCustomBtn]="isDeviceTablet"
                        [ngClass]="prevArrowClass"
                        class="swiper-button-prev swiper-button-prev-sp-custom"
                    ></div>
                    <div
                        [class.mobileCustomBtn]="isDeviceMobile"
                        [class.tabletCustomBtn]="isDeviceTablet"
                        [ngClass]="nextArrowClass"
                        class="swiper-button-next swiper-button-next-sp-custom"
                    ></div>
                }
                @if (thumbsSwiper && carouselOptions.type !== "default") {
                    <swiper
                        [class.mobileViewWrapper]="isDeviceMobile"
                        [class.tabletViewWrapper]="isDeviceTablet"
                        class="swipper-media-wrapper"
                        [config]="thumbsParentConfig"
                        style="--swiper-navigation-color: {{ carouselOptions.knobsColor }}; --swiper-navigation-size: {{
                            carouselOptions.arrowSize ? carouselOptions.arrowSize + 'px' : '44px'
                        }}; --swiper-navigation-size-tablet: {{
                            carouselOptions.arrowSizeTablet ? carouselOptions.arrowSizeTablet + 'px' : '44px'
                        }}; --swiper-navigation-size-mobile: {{
                            carouselOptions.arrowSizeMobile ? carouselOptions.arrowSizeMobile + 'px' : '44px'
                        }};"
                        [loop]="true"
                        [loopedSlides]="loopedSlides"
                        [navigation]="true"
                        [grabCursor]="true"
                        [spaceBetween]="0"
                        [slidesPerView]="1"
                        [allowTouchMove]="false"
                        (swiper)="setSwiper($event)"
                    >
                        @for (image of images; track instanceId(i, image); let i = $index) {
                            <ng-template swiperSlide>
                                <div
                                    class="image-wrapper"
                                    #resizeBox
                                    mwlResizable
                                    (resizeStart)="onResizeStart($event, resizeBox)"
                                    (resizing)="onResizing($event, resizeBox)"
                                    (resizeEnd)="onResizeEnd($event, resizeBox, i)"
                                    [class]="classes?.imageWrapper"
                                    [style.paddingTop.%]="getImagePaddingTop(images[i])"
                                    (mouseenter)="mouseImgIn(i)"
                                    (mouseleave)="mouseImgOut(i)"
                                >
                                    @if (image?.overlayImage) {
                                        <img
                                            #overlayImageRef
                                            [class]="classes?.gridImage + ' shape ' + classes?.['image' + i]"
                                            [ngClass]="{ overlayImage: overlayImageSrc(image) }"
                                            [style.objectPosition]="
                                                image &&
                                                (image.backgroundPositionX || 50) +
                                                    '% ' +
                                                    (image.backgroundPositionY || 50) +
                                                    '%'
                                            "
                                            [src]="overlayImageSrc(image)"
                                        />
                                    }
                                    <picture [spFallbackImg]="formatImageFallbackURL(image)">
                                        @for (source of image.srcSets; track source) {
                                            <source [srcset]="source.url" [media]="source.media" />
                                        }
                                        <img
                                            #imageRef
                                            [class]="classes?.gridImage + ' shape ' + classes?.['image' + i]"
                                            [ngClass]="image.isImageEffect && classes?.['imageMask' + i]"
                                            (load)="resizeOnload($event.target, resizeBox, i)"
                                            [src]="formatImageURL(image)"
                                            [alt]="image.alt"
                                            [style.objectPosition]="
                                                (image.backgroundPositionX || 50) +
                                                '% ' +
                                                (image.backgroundPositionY || 50) +
                                                '%'
                                            "
                                            (mousedown)="mouseDown($event, image)"
                                            (mousemove)="move($event, imageRef)"
                                            (mouseleave)="mouseUp(i)"
                                            (mouseup)="mouseUp(i)"
                                        />
                                    </picture>
                                    @if (image.isImageEffect) {
                                        <div [class]="classes?.['imageDescription' + i]">
                                            <div [class]="classes?.['text' + i]">
                                                <span>{{ image.description }}</span>
                                            </div>
                                        </div>
                                    }
                                    <div class="dragHandle bottom" mwlResizeHandle [resizeEdges]="{ bottom: true }">
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g>
                                                <path
                                                    d="M8.7071 15.6066C8.51956 15.7941 8.26519 15.8995 7.99998 15.8995C7.73476 15.8995 7.48042 15.7941 7.29288 15.6066L5.17156 13.4853C5.03195 13.3455 4.93688 13.1674 4.89837 12.9736C4.85986 12.7798 4.87963 12.5789 4.95519 12.3963C5.00566 12.275 5.07913 12.1645 5.17156 12.0711C5.35906 11.884 5.61311 11.779 5.87796 11.779L6.99943 11.779L7.00085 10C6.99854 9.86724 7.02271 9.73535 7.07192 9.61202C7.12113 9.48869 7.19441 9.3764 7.28749 9.28169C7.38056 9.18699 7.49155 9.11175 7.614 9.0604C7.73646 9.00905 7.86792 8.98263 8.0007 8.98263C8.13348 8.98263 8.26493 9.00906 8.38739 9.06041C8.50984 9.11176 8.62085 9.18698 8.71393 9.28168C8.807 9.37639 8.88029 9.48869 8.9295 9.61202C8.97871 9.73535 9.00286 9.86724 9.00055 10L8.99984 11.7783L10.1213 11.7783C10.3191 11.7784 10.5124 11.837 10.6768 11.9469C10.8412 12.0568 10.9693 12.2129 11.045 12.3956C11.1207 12.5783 11.1405 12.7793 11.102 12.9733C11.0634 13.1672 10.9682 13.3454 10.8284 13.4853L8.7071 15.6066ZM8.0007 6.99985C7.73554 6.99981 7.48124 6.89446 7.29374 6.70696C7.10625 6.51946 7.00089 6.26516 7.00085 6L7.00014 4.22167L5.87867 4.22167C5.68092 4.22164 5.48761 4.16299 5.3232 4.05312C5.15878 3.94325 5.03063 3.78708 4.95495 3.60438C4.87927 3.42168 4.85946 3.22067 4.89801 3.02672C4.93657 2.83276 5.03176 2.65458 5.17156 2.51472L7.29288 0.393397C7.48042 0.20586 7.73478 0.100513 8 0.100513C8.26521 0.100513 8.51956 0.20586 8.70709 0.393397L10.8284 2.51472C10.9679 2.65457 11.0629 2.83261 11.1013 3.02638C11.1398 3.22015 11.12 3.42097 11.0444 3.60349C10.9688 3.78602 10.8409 3.94206 10.6767 4.05195C10.5126 4.16185 10.3196 4.22065 10.122 4.22096L9.00055 4.22096L9.00055 6C9.00051 6.26516 8.89516 6.51946 8.70766 6.70696C8.52016 6.89446 8.26586 6.99981 8.0007 6.99985Z"
                                                    fill="white"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </ng-template>
                        }
                    </swiper>
                }
                @if (carouselOptions.type !== "default") {
                    <div class="thumbs-swiper-container" [class]="classes?.thumbsSwiperContainer">
                        <swiper
                            class="thumbsSwiper"
                            (swiper)="setThumbs($event)"
                            [breakpoints]="getSwiperThumbsBreakpoints(isDeviceMobile, isDeviceTablet)"
                            [watchSlidesProgress]="true"
                            [allowTouchMove]="false"
                        >
                            @for (image of images; track instanceId(i, image); let i = $index) {
                                <ng-template swiperSlide>
                                    <div
                                        [class]="classes?.thumbWrapper"
                                        class="thumb-wrapper"
                                        #resizeThumbBox
                                        mwlResizable
                                        (resizeStart)="onResizeThumbStart($event, resizeThumbBox)"
                                        (resizing)="onResizingThumb($event, resizeThumbBox)"
                                        (resizeEnd)="onResizeThumbEnd($event, resizeThumbBox)"
                                        [style.maxHeight.px]="getThumbMaxHeight()"
                                    >
                                        <picture [spFallbackImg]="formatImageFallbackURL(image)">
                                            <img
                                                [class]="classes?.thumbImage"
                                                [src]="formatImageURL(image)"
                                                [alt]="image.alt"
                                            />
                                        </picture>
                                        <div class="dragHandle bottom" mwlResizeHandle [resizeEdges]="{ bottom: true }">
                                            <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g>
                                                    <path
                                                        d="M8.7071 15.6066C8.51956 15.7941 8.26519 15.8995 7.99998 15.8995C7.73476 15.8995 7.48042 15.7941 7.29288 15.6066L5.17156 13.4853C5.03195 13.3455 4.93688 13.1674 4.89837 12.9736C4.85986 12.7798 4.87963 12.5789 4.95519 12.3963C5.00566 12.275 5.07913 12.1645 5.17156 12.0711C5.35906 11.884 5.61311 11.779 5.87796 11.779L6.99943 11.779L7.00085 10C6.99854 9.86724 7.02271 9.73535 7.07192 9.61202C7.12113 9.48869 7.19441 9.3764 7.28749 9.28169C7.38056 9.18699 7.49155 9.11175 7.614 9.0604C7.73646 9.00905 7.86792 8.98263 8.0007 8.98263C8.13348 8.98263 8.26493 9.00906 8.38739 9.06041C8.50984 9.11176 8.62085 9.18698 8.71393 9.28168C8.807 9.37639 8.88029 9.48869 8.9295 9.61202C8.97871 9.73535 9.00286 9.86724 9.00055 10L8.99984 11.7783L10.1213 11.7783C10.3191 11.7784 10.5124 11.837 10.6768 11.9469C10.8412 12.0568 10.9693 12.2129 11.045 12.3956C11.1207 12.5783 11.1405 12.7793 11.102 12.9733C11.0634 13.1672 10.9682 13.3454 10.8284 13.4853L8.7071 15.6066ZM8.0007 6.99985C7.73554 6.99981 7.48124 6.89446 7.29374 6.70696C7.10625 6.51946 7.00089 6.26516 7.00085 6L7.00014 4.22167L5.87867 4.22167C5.68092 4.22164 5.48761 4.16299 5.3232 4.05312C5.15878 3.94325 5.03063 3.78708 4.95495 3.60438C4.87927 3.42168 4.85946 3.22067 4.89801 3.02672C4.93657 2.83276 5.03176 2.65458 5.17156 2.51472L7.29288 0.393397C7.48042 0.20586 7.73478 0.100513 8 0.100513C8.26521 0.100513 8.51956 0.20586 8.70709 0.393397L10.8284 2.51472C10.9679 2.65457 11.0629 2.83261 11.1013 3.02638C11.1398 3.22015 11.12 3.42097 11.0444 3.60349C10.9688 3.78602 10.8409 3.94206 10.6767 4.05195C10.5126 4.16185 10.3196 4.22065 10.122 4.22096L9.00055 4.22096L9.00055 6C9.00051 6.26516 8.89516 6.51946 8.70766 6.70696C8.52016 6.89446 8.26586 6.99981 8.0007 6.99985Z"
                                                        fill="white"
                                                    />
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                </ng-template>
                            }
                        </swiper>
                    </div>
                }
            }
        }
    </div>
</div>
